// src/blog/blogSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { posts as initialPosts, BlogPost } from './posts';

export interface BlogState {
  posts: BlogPost[];
}

const initialState: BlogState = {
  posts: initialPosts,
};

const blogSlice = createSlice({
  name: 'blog',
  initialState,
  reducers: {
    addPost(state, action: PayloadAction<BlogPost>) {
      // prevent duplicates by id (language-agnostic)
      const exists = state.posts.some(p => p.id === action.payload.id);
      if (!exists) {
        state.posts.unshift(action.payload);
      }
    },
  },
});

export const { addPost } = blogSlice.actions;
export default blogSlice.reducer;

// selectors
export const selectAllPosts = (state: any): BlogPost[] => state.blog?.posts || [];
export const selectPostById = (id: string) => (state: any): BlogPost | undefined =>
  (state.blog?.posts || []).find((p: BlogPost) => p.id === id);
export const selectPostIdByLegacySlug = (slug: string) => (state: any): string | undefined => {
  const found = (state.blog?.posts || []).find((p: BlogPost) =>
    Object.values(p.translations || {}).some((t: any) => t?.slug === slug)
  );
  return found?.id;
};
